"use strict";

import React from "react";
import Button from "./Button";

function EditableValue(props) {
  const { value, btnText, onClick } = props;

  const style = {
    display: "flex",
    alignItems: "baseline",
    cursor: "pointer",
  };

  return (
    <div style={style} onClick={onClick}>
      {value && <span style={{ paddingRight: 8 }}>{value}</span>}
      <Button className="si-c-btn--edit">{btnText}</Button>
    </div>
  );
}

EditableValue.defaultProps = {
  btnText: "Edit",
};

export default EditableValue;
